import { v4 } from "uuid";
import { Secret } from "../models/Secret";
import axios from "axios";

export const getSecrets = async (
    accessToken: string,
): Promise<Secret[]> => {
    const response = await axios.get(process.env.REACT_APP_API_URL + '/v1/secrets', {
        headers: {
            'Authorization': accessToken,
            'X-Request-ID': v4()
        }
    });

    if (response.status !== 200) {
        throw new Error('Failed to get secrets');
    }

    return response.data as Secret[];
}

export const getSecretValue = async (
    secretId: string,
    accessToken: string,
): Promise<Secret> => {
    const response = await axios.get(process.env.REACT_APP_API_URL + `/v1/secrets/${secretId}`, {
        headers: {
            'Authorization': accessToken,
            'X-Request-ID': v4()
        }
    });

    if (response.status !== 200) {
        throw new Error('Failed to get secret value');
    }

    return response.data as Secret;
}

export const createSecret = async (
    secret: Secret,
    accessToken: string,
): Promise<string> => {
    const response = await axios.post(process.env.REACT_APP_API_URL + '/v1/secrets', secret, {
        headers: {
            'Authorization': accessToken,
            'X-Request-ID': v4()
        }
    });

    if (response.status !== 201) {
        throw new Error('Failed to create secret');
    }

    return response.data.id as string;
}

export const updateSecret = async (
    secret: Secret,
    accessToken: string,
): Promise<void> => {
    const response = await axios.put(process.env.REACT_APP_API_URL + `/v1/secrets/${secret.id}`, secret, {
        headers: {
            'Authorization': accessToken,
            'X-Request-ID': v4()
        }
    });

    if (response.status !== 204) {
        throw new Error('Failed to update secret');
    }
}

export const deleteSecret = async (
    secretId: string,
    accessToken: string,
): Promise<void> => {
    const response = await axios.delete(process.env.REACT_APP_API_URL + `/v1/secrets/${secretId}`, {
        headers: {
            'Authorization': accessToken,
            'X-Request-ID': v4()
        }
    });

    if (response.status !== 204) {
        throw new Error('Failed to delete secret');
    }
}
